import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, GlobalStore } from '../../reduxStore';
import ApiServiceFactory from '../../services/api/ApiServiceFactory';
import { translateService } from '../../services/TranslateService';
import LoginView from './LoginView';
import ApiService from '../../services/api/ApiService';
import { User } from '../../interfaces/User';
import { ResponseModalStruct } from '../../interfaces/ModalStructs';
import ResponseModal from '../ResponseModal/ResponseModal';
import moment from 'moment';
import {checkBirthdateFromLogin} from"../../hooks/useCustomerHooks";

interface LoginContainerState {
  step: number;
  phoneNumber: string;
  apiMessage: string;
  responseModal: ResponseModalStruct | undefined;
  fetchedToken: string | undefined;
  fetchedJwt: string | undefined;
  redirect: string;
  keepState: boolean;
}

interface StateFromProps {
  token: string;
  jwt: string;
  mock: string;
  API_URL: string;
  API_VERSION: string;
  language: string;
  setRedirect: Function;
  closeModal?: () => void;
  setUser: Function;
  setIsLoggedIn: Function
  clearUserSelections: Function;
  sendGaEvent: Function;
  appContext: string;
  rootUrl: string;
}

interface DispatchFromProps {
  // Redux dispatch options referenced as props
  onSetToken: (tokenObject: { token: string; jwt: string; driverLogin: boolean }) => void;
  onClearUserSelections: () => void;
  onSetApi: (apiService: any) => void;
}

class LoginContainer extends React.Component<DispatchFromProps & StateFromProps, LoginContainerState> {
  api: ApiService;

  constructor(props: any) {
    super(props);
    this.state = {
      step: 0,
      phoneNumber: localStorage.getItem('C2-PN') || '',
      apiMessage: '',
      responseModal: undefined,
      fetchedToken: undefined,
      fetchedJwt: undefined,
      redirect: '',
      keepState: true
    };
    this.api = ApiServiceFactory(this.props.token, this.props.jwt, this.props.mock, this.props.API_URL, this.props.appContext,undefined, true);
  }

  componentWillMount() {
    if (this.state.phoneNumber !== '') {
      this.setState({ step: 1 });
    }
  }

  componentDidMount() {
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = (event: any) => {
      window.history.go(1);
    };

    const closeButton = document.querySelector('.modal-close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.onReset();
        // @ts-ignore
        this!.props!.closeModal(); // Call closeModal function
      });
    }
  }

  onNumberSubmit = (phoneNumber: string) => {
    localStorage.setItem('C2-PN', phoneNumber);
    this.setState({
      phoneNumber,
      apiMessage: translateService.translate('loginScreen.generatingPin'),
    });
    this.api.login
      .getPIN(phoneNumber)
      .then((res: any) => {
        this.setState({
          apiMessage: '',
          step: 1,
        });
        if (this.props.appContext !== 'production') {
          console.log('PIN1 RES:', res);
          alert('PIN: ' + res.pin);
        }
      })
      .catch((res: any) => {
        if (res.includes('CUSTOMER_NOT_FOUND_ERROR')) {
          // log the attempted phone number

          // act as though the submission worked
          //  this.setState({
          //   step: 1,
          // });
          this.setState({
            responseModal: {
              // open: true,
              justify: 'left',
              text: translateService.translate('loginScreen.invalidCredentialsError'),
              buttonText: translateService.translate('loginScreen.buttonOk'),
            },
          });
        } else
          if (res.includes('TWO_FACTOR_AUTHENTICATION_PIN_UNSENDABLE_ERROR')) {
            this.setState({
              responseModal: {
                // open: true,
                justify: 'left',
                text: translateService.translate('loginScreen.pinRequestFailed'),
                buttonText: translateService.translate('loginScreen.buttonOk'),
              },
            });
          } else {
            this.setState({
              responseModal: {
                // open: true,
                justify: 'left',
                text: translateService.translate('loginScreen.pinRequestFailed'),
                buttonText: translateService.translate('loginScreen.buttonOk'),
              },
            });
          }
        this.setState({
          apiMessage: '',
          responseModal: {
            // open: true,
            text: translateService.translate('loginScreen.invalidCredentialsError'),
            buttonText: translateService.translate('loginScreen.buttonOk')
          }
        });
        if (this.props.appContext !== 'production') {
          alert(JSON.stringify(res));
        }
      });
  };

  onPINSubmit = (pin: string, phoneNumber: string) => {
    this.setState({
      apiMessage: translateService.translate('loginScreen.loggingIn'),
    });
    this.api.login
      .tryPIN(pin, phoneNumber)
      .then((res: any) => {
        if (this.props.appContext !== 'production') {
          console.log('PIN2 RES:', res);
        }
        localStorage.removeItem('C2-PN');
        localStorage.setItem('loginTime', moment().format());
        if (!res.jwt) {
          res.jwt = 'notimplemented'
        }
        this.api.user.fetchUser(res.token, res.jwt).then((user: User) => {
          this.setState({
            apiMessage: '',
            fetchedToken: res.token,
            fetchedJwt: res.jwt,
          });

          if (checkBirthdateFromLogin(user.birthDate)) { // if birthdate exist + valid format, else ask user to add again like new customer
            this.props.setUser({...user, saveToCustomer: true, smsLogin: true});
            this.props.setIsLoggedIn(true);
          } else {
            // birthdate not valid, then make undefined and ask for new birthdate/ssn
            this.props.setUser({...user, saveToCustomer: true, birthDate: undefined, smsLogin: false});
            this.props.setIsLoggedIn(false);
          }

          if ((window as any).ap3c && user.email){
            // add customer when we know the email and if ap3c func exists
            console.log('Ortto Tracking on');
            (window as any).ap3c.track({"v":0 ,"email": user.email});
          }

          let date = new Date();
          date.setTime(date.getTime() + (10 * 365 * 24 * 60 * 60 * 1000)); // 10 year cookie
          document.cookie = "smclient=" + user.salesManagoId + ";expires=" + date.toUTCString() + ";domain=.24rent.fi";  // set cookie for SalesManago
          this.props.onSetToken({ token: res.token, jwt: res.jwt, driverLogin: false });
          this.props.setRedirect();
          this.props.sendGaEvent('customer', 'loginSuccess', '', 0);
        }).catch(e => {
            this.props.onSetToken({ token: res.token, jwt: res.jwt, driverLogin: true });
            this.setState({
              apiMessage: '',
              fetchedToken: res.token,
              fetchedJwt: res.jwt
            });
            //let date = new Date();
            //date.setTime(date.getTime()+(10*365*24*60*60*1000)); // 10 year cookie
            //document.cookie = "smclient="+user.salesManagoId+";expires="+date.toGMTString()+";domain=.24rent.fi";  // set cookie for SalesManago
          });

        if (!this.state.keepState) {
          this.props.clearUserSelections();
          this.props.onClearUserSelections();
        }
        else {
          const apiService = ApiServiceFactory(
            res.token || "",
            res.jwt || "",
            this.props.API_VERSION,
            this.props.API_URL,
              this.props.appContext || ""
          );
          this.props.onSetApi(apiService);
        }
      })
      .catch((err) => {
        localStorage.removeItem('C2-PN');

        let errMsg = 'loginScreen.unknownError';
        if (err === 'TWO_FACTOR_AUTHENTICATION_PIN_INCORRECT_ERRORZZ') {
          errMsg = 'loginScreen.invalidCredentialsError';
        }
        this.setState({
          apiMessage: '',
          responseModal: {
            justify: 'left',
            text: translateService.translate(errMsg),
            buttonText: translateService.translate('loginScreen.buttonOk'),
          },
        });
        this.props.sendGaEvent('customer', 'loginFail', '', 0);
      });
  };

  onReset = () => {
    localStorage.removeItem('C2-PN');
    this.setState({ step: 0 });
    this.setState({ phoneNumber: '' });
  };

  render() {
    return (
        <React.Fragment>
          <ResponseModal
              response={this.state.responseModal}
              closeFunc={() => this.setState({responseModal: undefined})}
          />
          <div className={"modal-close-container"}>
            <button className={"modal-close"} id={"close-login-btn"} onClick={() => this.setState({responseModal: undefined})}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                <path
                    d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"/>
              </svg>
            </button>
          </div>
          <LoginView
              language={this.props.language}
              step={this.state.step}
              phoneNumber={this.state.phoneNumber}
              onNumberSubmit={this.onNumberSubmit}
              onPINSubmit={this.onPINSubmit}
              onReset={this.onReset}
              onEmailLink={() => {
                this.api.login.sendAutoLink(this.state.phoneNumber);
                this.setState({
                  responseModal: {
                    // open: true,
                    justify: 'left',
                    text: translateService.translate('loginScreen.emailLinkInfo'),
                    buttonText: translateService.translate('loginScreen.buttonOk'),
                  },
                });
              }}
              apiMessage={this.state.apiMessage}
              // emailLinkVisible={this.state.step !== 0}
              emailLinkVisible={false}
              rootUrl={this.props.rootUrl}
          />
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state: GlobalStore) => {
  // authToken becomes the prop on this container, for redux state's dbToken property
  return {
    API_URL: state.chauffeurReducer.API_URL,
    API_VERSION: state.chauffeurReducer.API_VERSION,
    token: state.chauffeurReducer.dbToken,
    jwt: state.chauffeurReducer.jwt,
    mock: state.chauffeurReducer.API_VERSION,
    language: state.chauffeurReducer.deviceLanguage,
    // userPhoto: state.map.userPhoto,
    // phase: state.map.phase
  };
};

// which actions to I want to dispatch? = mapDispatchToProps
const mapDispatchToProps = (dispatch: Dispatch): DispatchFromProps => {
  return {
    onSetToken: (tokenObject: { token: string; jwt: string; driverLogin: boolean }) => {
      dispatch({
        type: 'SET_TOKEN',
        payload: tokenObject,
      });
    },
    onClearUserSelections: () => {
      dispatch({
        type: 'CLEAR_SELECTIONS',
        payload: null,
      });
    },
    onSetApi: (apiService: any) => {
      dispatch({ type: 'SET_API_SERVICE', payload: apiService })
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginContainer);
